export var ViewType;
(function (ViewType) {
    ViewType[ViewType["LANDSCAPE"] = 0] = "LANDSCAPE";
    ViewType[ViewType["PORTRAIT"] = 1] = "PORTRAIT";
})(ViewType || (ViewType = {}));
